import React from 'react';
import { useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import moment from 'moment';

import styles from './GuestModifiedModal.module.css';


function GuestModifiedModal(props) {

  const {
    mode,
    show,
    onHide,
    values,
    handleDelete,
  } = props;

  const rentals = useSelector(({ rentals }) => rentals && rentals.rentals);
  const guests = useSelector(({ guests }) => guests && guests.guestList);

  const targetName = mode === 'notification' ? 'Notification' : 'Activity';
  const bookingData = (values?.bookingData && values.bookingData[0]);

  const guestData = (() => {
    return guests.find((guest) => guest.id === bookingData?.guestId);
  })();

  // TODO: previousGuestData
  const previousGuestData = (() => {
    return guests.find((guest) => guest.id === bookingData?.guestId);
  })();
  
  const getRentalNameById = (rentalId) => {
    return rentals.find(rental => rental.id === rentalId)?.name || 'N/A';
  };

  const handleAction = () => {
    if (values) {
      const { id } = values;
      handleDelete(id);
    };
    onHide();
  };

  const handleClose = () => {
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size='md'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id='contained-modal-title-vcenter'
          className={styles.modalTitle}
        >
          {values?.message}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        <p>
          The guest or booker contact information for a reservation has been modified.
        </p>
        <p>Reservation affected:</p>
        <p style={{display: "flex"}}>
          <div style={{paddingLeft: "20px"}}>
            <div>Reservation:</div>
            <div>Rental:</div>
            <div>Arrival date:</div>
          </div>
          <div style={{paddingLeft: "70px"}}>
            <div>{bookingData?.suBookingId}</div>
            <div>{getRentalNameById(bookingData?.rentalId)}</div>
            <div>{moment(bookingData?.arrive).format('DD MMMM YYYY')}</div>
          </div>
        </p>
        <p>New contact details:</p>
        <p style={{display: "flex"}}>
          <div style={{paddingLeft: "20px"}}>
            <div>Name:</div>
            <div>E-mail:</div>
            <div>Phone nr.:</div>
          </div>
          <div style={{paddingLeft: "70px"}}>
            <div>{guestData?.name}</div>
            <div>{guestData?.emailId || "N/A"}</div>
            <div>{guestData?.phoneNo || "N/A"}</div>
          </div>
        </p>
        <p>Previous contact details:</p>
        <p style={{display: "flex"}}>
          <div style={{paddingLeft: "20px"}}>
            <div>Name:</div>
            <div>E-mail:</div>
            <div>Phone nr.:</div>
          </div>
          <div style={{paddingLeft: "70px"}}>
            <div>{previousGuestData?.name}</div>
            <div>{previousGuestData?.emailId || "N/A"}</div>
            <div>{previousGuestData?.phoneNo || "N/A"}</div>
          </div>
        </p>
        <div className={styles.modalButtonContainer}>
          <button
            onClick={handleClose}
            className={styles.grayButton}
          >
            Close
          </button>
          { mode === 'notification' &&
            <button
              onClick={handleAction}
              className={styles.redButton}
            >
              Delete Notification
            </button>
          }
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default GuestModifiedModal;